module.exports = __webpack_public_path__ + "media/result.31cab3b6.mp4";